module.exports = __webpack_public_path__ + "img/clock-bordered.6ca8d32a.svg";